var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 671,
    viewBox: "0 0 336 671",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499971 671C44.5585 671 88.1855 662.322 128.89 645.462C169.595 628.601 206.58 603.888 237.734 572.734C268.888 541.58 293.601 504.595 310.462 463.89C327.322 423.186 336 379.558 336 335.5C336 291.441 327.322 247.814 310.462 207.11C293.601 166.405 268.888 129.42 237.734 98.2657C206.58 67.1116 169.595 42.3988 128.89 25.5384C88.1855 8.67795 44.5585 -1.6591e-05 0.499969 -1.46652e-05L0.499969 5.25768C43.868 5.25767 86.8114 13.7996 126.878 30.3959C166.945 46.9921 203.351 71.3176 234.017 101.983C264.682 132.649 289.008 169.055 305.604 209.122C322.2 249.189 330.742 292.132 330.742 335.5C330.742 378.868 322.2 421.811 305.604 461.878C289.008 501.945 264.682 538.351 234.017 569.017C203.351 599.682 166.945 624.008 126.878 640.604C86.8114 657.2 43.868 665.742 0.499971 665.742L0.499971 671Z",
    fill: "#FA6A0A",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseBack);
export default __webpack_public_path__ + "static/media/ellipseBack.f99a215af4e48c4bb1da9e37b984b53a.svg";
export { ForwardRef as ReactComponent };